import React from 'react';
import { NavLink } from 'react-router-dom';
import { useCart } from 'react-use-cart';

const Navbar = () => {
  const { totalItems } = useCart();

  return (
    <nav className="sidebar">
      <div className="brand">
        GOURMET
      </div>
      
      <div className="nav-links">
        <NavLink to="/" className={({isActive}) => `nav-item-link ${isActive ? 'active' : ''}`}>
          <i className="bi bi-house-door"></i> Home
        </NavLink>
        <NavLink to="/menu" className={({isActive}) => `nav-item-link ${isActive ? 'active' : ''}`}>
          <i className="bi bi-grid"></i> Menu
        </NavLink>
        <NavLink to="/about" className={({isActive}) => `nav-item-link ${isActive ? 'active' : ''}`}>
          <i className="bi bi-info-circle"></i> About
        </NavLink>
        <NavLink to="/gallery" className={({isActive}) => `nav-item-link ${isActive ? 'active' : ''}`}>
          <i className="bi bi-images"></i> Gallery
        </NavLink>
        <NavLink to="/contact" className={({isActive}) => `nav-item-link ${isActive ? 'active' : ''}`}>
          <i className="bi bi-envelope"></i> Contact
        </NavLink>
      </div>

      <div className="cart-widget">
         <div className="mb-2 text-secondary"><small>Your Order</small></div>
         <h3 className="text-white fw-bold">{totalItems} Item(s)</h3>
         <NavLink to="/cart" className="btn btn-gold w-100 mt-2">
            View Cart
         </NavLink>
      </div>
    </nav>
  );
};

export default Navbar;
